interface AmountInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function AmountInput({
  label,
  value,
  onChange,
  placeholder = '0.00',
}: AmountInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9.]/g, '');
    const parts = value.split('.');
    if (parts.length > 2) return;
    if (parts[1] && parts[1].length > 2) return;
    onChange(value);
  };

  return (
    <div className='flex items-center justify-between'>
      <label className='flex-1 text-sm font-medium text-gray-700'>
        {label}
      </label>
      <div className='relative ml-4 w-[200px] rounded-md shadow-sm'>
        <div className='pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3'>
          <span className='text-gray-500 sm:text-sm'>$</span>
        </div>
        <input
          type='text'
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          className='block w-full rounded-md border-gray-300 py-2 pl-7 pr-3 focus:border-blue-500 focus:ring-blue-500 sm:text-sm'
        />
      </div>
    </div>
  );
}
